module.exports = __webpack_public_path__ + "img/cx.a60e6405.svg";